module.exports = __webpack_public_path__ + "static/media/4.81cf3b44.jpg";